import { APP_INITIALIZER, Injector, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Router, RouteReuseStrategy } from "@angular/router";

import {
  IonicModule,
  IonicRouteStrategy,
  NavParams,
  Platform,
} from "@ionic/angular";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { HttpClientModule } from "@angular/common/http";

import { AuthenticationService } from "./services/authentication/authentication.service";
import { GlobalErrorHandlerService } from "./services/global-errors/global-error-handler.service";
import { UserSessionService } from "./services/user-session/user-session.service";
import { LogoutService } from "./services/logout/logout.service";
import { ServicesSharedModule } from "./services/services-shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ConfigService } from "./services/config/config.service";
import { ComponentsModule } from "./components/components.module";
import { pagesModule } from "./pages/pages.module";
import { IonicStorageModule } from "@ionic/storage-angular";
import { TouchID } from "@ionic-native/touch-id/ngx";
import { Device } from "@ionic-native/device/ngx";
import { CommonModule, DatePipe } from "@angular/common";
import { AuthGuardService } from "./services/auth-guard/auth-guard.service";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { ODRModule } from "./mobile/odr-module";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { NotificationApiService } from "./services/notification-api/notification-api.service";
import { AppstorageTsService } from "./services/appstorage/appstorage.ts.service";
import { NgIdleModule } from '@ng-idle/core';
import { TabLandingPageModule } from "./tabs/tab-landing/tab-landing.module";
import { MarketingService } from "./services/marketing/marketing.service";
import { customTabAnimation } from "./animation/animation";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { directivesModule } from "./directives/directives.module";
import { AudioService } from "./services/audio/audio.service";

//each domain should contain 'default_roue' propertry defined in environment.config file which code checks which specific routes to load

const ROUTES = [
  {
    path: "home",
    loadChildren: () =>
      import("./tabs/tab-home/tab-home.module").then(
        (m) => m.TabHomePageModule
      ),
  },
  {
    path: "casino",
    loadChildren: () =>
      import("./tabs/tab-casino/tab-casino.module").then(
        (m) => m.TabCasinoPageModule
      ),
  },
  {
    path: "launcher",
    loadChildren: () =>
      import("./tabs/tab-game/tab-game.module").then(
        (m) => m.TabGamePageModule
      ),
  },
  {
    path: "webview",
    loadChildren: () =>
      import("./tabs/tab-webview/tab-webview.module").then(
        (m) => m.TabWebviewPageModule
      ),
  },
  {
    path: "c",
    redirectTo: "webview",
    pathMatch: "prefix",
  },
  {
    path: "",
    redirectTo: "casino",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "casino",
    pathMatch: "full",
  },
];

export function init_app(
  injector: Injector,
  config: ConfigService,
) {
  return () =>
    new Promise((resolve) => {
      let routes = [];
      config.isLoaded().then(() => {
        routes = ROUTES;
        const router: Router = injector.get(Router);
        router.resetConfig(routes);
        resolve(this);
      })
    });
}

const ionicRootOptions = {
  rippleEffect: false,
  navAnimation: customTabAnimation
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(ionicRootOptions),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    ServicesSharedModule,
    ComponentsModule,
    directivesModule,
    CommonModule,
    FormsModule,
    pagesModule,
    NgIdleModule.forRoot(),
    ODRModule.forRoot(),
    TabLandingPageModule,
  ],

  providers: [
    ConfigService,
    AudioService,
    AppstorageTsService,
    MarketingService,
    Platform,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [Injector, ConfigService, AppstorageTsService, MarketingService, Platform],
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    ,
    AuthenticationService,
    GlobalErrorHandlerService,
    LogoutService,
    NotificationApiService,
    UserSessionService,
    AuthGuardService,
    InAppBrowser,
    TouchID,
    Device,
    DatePipe,
    CommonModule,
    NavParams,
    ScreenOrientation,
    FileOpener,
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
